<template lang="pug">
  form(:action="action" method="POST")
    template(v-if="label")
      label(for="message" class="mb-3" data-cy="labelTitle") {{ label }}
      textarea(class="form-control" id="message" name="message" rows="5" data-cy="labelText")      
    slot
    span.error(v-if="error") {{ error }}
    span.successful(v-if="successful") {{ successful }}
    .d-flex.justify-content-end.mt-3
      button(type="submit" class="btn btn-primary btn__Send hvr-shrink" data-cy="submit") {{ t('send') }}

</template>

<script>
import Vue from 'vue'
import mixins from 'common/mixins'

export default Vue.extend({
  name: 'custom-form-vue',
  props: {
    action: { type: String, default: ''},
    label: { type: String, default: '' },
    error: { type: String, default: '' },
    successful: { type: String, default: '' }
  },
  mixins: [mixins.translate]
})
</script>
